import superagent from 'superagent';

const API_KEY = 'ef3c2f0f986ba72aee8550f05fd1f6ed';


module.exports = {
  getWeatherData(units, coords) {
    return new Promise((resolve, reject) => {
      const parsedUnits = units === 'C' ? 'metric' : 'imperial';

      superagent
      .get('https://api.openweathermap.org/data/2.5/weather')
      .query({
        units: parsedUnits,
        lat: coords.lat,
        lon: coords.lon,
        appid: API_KEY
      })
      .end((error, weatherData) => {
        if (error) {
          reject(error);
        } else {
          resolve(weatherData);
        }
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/weather.js